import React, { useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { Grid, TextField, Typography, Button } from '@mui/material';
import { useMutation } from 'react-query';
import { API } from 'core/requests';
import { useCompany } from 'contexts'
import CardSection from './CardSection';
import { Box } from '@mui/system';
import { useSnackbar } from 'notistack';
import { MoneyInput } from 'components'


export default function CheckoutForm({ handleClose, setWalletMoney, amount, getCurrentTransaction, refreshTableData }: {
  handleClose: any;
  setWalletMoney: any;
  amount: any;
  getCurrentTransaction: () => void;
  refreshTableData: () => void;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { company } = useCompany()!

  const stripe = useStripe();
  const elements = useElements();

  const com_id: any = company?.id;
  const credit_card_fee_type: any = company?.credit_card_fee_type;
  const credit_card_fee: any = company?.credit_card_fee;

  let totalAmount = parseFloat(amount);
  if (credit_card_fee_type === 'percentage') {
    const fee = (parseFloat(amount) * credit_card_fee) / 100;
    totalAmount = parseFloat(amount) + fee;
  } else if (credit_card_fee_type === 'fixed') {
    totalAmount = parseFloat(amount) + credit_card_fee;
  } 

  const [totalWalletMoney, setTotalWalletMoney] = useState<number>(totalAmount);

  const { mutate: addmoneyCard } = useMutation(
    (payload: any) => API.createOrUpdate('addMoneyWithCart', payload),
    {
      onSuccess: (response: any) => {
        if (!response.errors) {
          setWalletMoney(1.0);
          enqueueSnackbar(
            'Deposit in progress.  Please allow 3-4 business days for the processing.',
            { variant: 'success' },
          );
          getCurrentTransaction();
          refreshTableData();
        }
      },
    },
  )

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSubmit = async (event) => {
    if (!stripe || !elements) {
      return;
    }

    const card: any = elements.getElement(CardElement);
    const result = await stripe.createToken(card);

    if (result.error) {
      // Show error to your customer.
      enqueueSnackbar(result?.error.message,
        { variant: 'error' },
      );
    } else {
      const cartData = {
        amount: parseFloat(totalWalletMoney.toFixed(2)),
        currency: "usd",
        company_id: com_id,
        token: result.token?.id,
        stripe_data: result.token
      }
      addmoneyCard(cartData)
      handleClose();
    }
  };

  return (
    <>
      <CardSection />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box display={'flex'} alignItems={'center'} mt={4}>
            <TextField
              data-cy='amount'
              id='amount'
              name='amount'
              label={'Reward Deposit Amount'}
              variant='outlined'
              value={parseFloat(amount)}
              required
              onChange={(event: any) => {
                setWalletMoney(parseFloat(event.target.value).toFixed(2));
                if (credit_card_fee_type === 'percentage') {
                  const fee = (parseFloat(event.target.value) * credit_card_fee) / 100;
                  const total = parseFloat(event.target.value) + fee;
                  setTotalWalletMoney(total || 0);
                } else if (credit_card_fee_type === 'fixed') {
                  const total = parseFloat(event.target.value) + credit_card_fee;
                  setTotalWalletMoney(total || 0);
                } else {
                  setTotalWalletMoney(parseFloat(event.target.value));
                }
              }}
              fullWidth
              margin='normal'
              InputProps={{
                inputComponent: MoneyInput,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{marginTop: 0}}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container mt={3}>
            <Grid item xs={5}>
              <Typography variant='h6' component='h6' fontWeight={500} textAlign={"end"} >
                Transaction Fee:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant='h6' color={'#000000'} component='h6' fontWeight={600} textAlign={"end"} >
                {
                  credit_card_fee_type === 'percentage' 
                  ? `${credit_card_fee}%` 
                  : credit_card_fee_type === 'fixed' 
                    ? `$${credit_card_fee.toFixed(2)}` 
                    : '$0.00'
                } 
              </Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography variant='h6' component='h6' fontWeight={500} textAlign={"end"} >
                Transaction Total:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant='h6' color={'#000000'} component='h6' fontWeight={600} textAlign={"end"}>
                {`$${totalWalletMoney.toFixed(2)}`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box mt={3}>
        <Button variant="contained" color={'primary'} fullWidth onClick={(e) => handleSubmit(e)}>Pay</Button>
      </Box>
    </>
  );
}